import { render } from "./OfferMainData.vue?vue&type=template&id=5585c268"
import script from "./OfferMainData.vue?vue&type=script&lang=js"
export * from "./OfferMainData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__